import { ApiService } from "src/network/apiService";
import { IApiResponse } from "src/network/models/ApiResponse";
import { ICreateSupportTicketResponse, ISupportRequest } from "./support-ticket-request";


export class SupportTicketViewModel {

    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }


    async createSupportTicket(request: ISupportRequest): Promise<ICreateSupportTicketResponse> {
        console.log(request);
        const URL = `/insights/support-case`;

        try {
            const response = await this.apiService.postAsync<IApiResponse<string>, ISupportRequest>(
                URL, request);

            if (response && response.scResponse && response.scResponse.code === 2000) {
                console.log(`response`, response)
                return {
                    success: true,
                    message: response.scResponse.data
                };
            } else {
                return {
                    success: false,
                    message: "failed to create support ticket"
                };
            }
        } catch (error) {
            console.error(error)
            return {
                success: false,
                message: "error while creating support ticket"
            };
        }
        return {
            success: false,
            message: "failed to create support ticket"
        };
    }
}